import script from "./Msg.vue?vue&type=script&setup=true&lang=js"
export * from "./Msg.vue?vue&type=script&setup=true&lang=js"

import "./Msg.vue?vue&type=style&index=0&id=365cd4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365cd4aa"]])

export default __exports__